/**
* Represents codename of Kentico Cloud field types
*/
export enum FieldType {
    Text = 'text',
    Number = 'number',
    ModularContent = 'modular_content',
    Asset = 'asset',
    DateTime = 'date_time',
    RichText = 'rich_text',
    MultipleChoice = 'multiple_choice',
    UrlSlug = 'url_slug',
    Taxonomy = 'taxonomy'
}
